export const DEBOUNCED_SEARCH_DURATION = 500 // in milliseconds
